'use strict';

frontendApp.directive('iioTagBoolean', ['TagService', 'NotificationService', function (TagService, NotificationService) {
  return {
    restrict: 'E',
    templateUrl: 'partials/tagging/tag_boolean.html',
    scope: {
      boolModel: '=',
      tags: '=',
      project: '='
    },
    link: function (scope, element, attrs) {
      console.log("tagBoolean", scope.boolModel);
    }
  }
}]);
